import React, { useState, useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { UserContext } from 'contexts/UserContext';
import logoExcel from 'assets/img/logoExcel.png';
import logoExcelRound from 'assets/img/Excel-2-icon.png';
import logoTxt from 'assets/img/logoTxt.png';
import logoAlert from 'assets/img/senal-de-peligro.png';
import logoDownload from 'assets/img/download-white.png';
import flecha from 'assets/img/imageInvert.png';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import ExcelJS from 'exceljs';
import ImportAlumnesModal from 'components/ui/Modals/ImportAlumnesModal';

export default function StudentsTableBar({
  previousPage,
  canPreviousPage,
  pageIndex,
  pageOptions,
  nextPage,
  canNextPage,
  pageSize,
  setPageSize,
  datos,
  onSuccess,
  onSuccessPracts,
  activeMonthKey,
}) {
  const [file, setFile] = useState(null);
  const { user } = useContext(UserContext);
  const [schoolData, setSchoolData] = useState({});
  const [studentData, setStudentData] = useState([]);
  const [studentDataMap, setStudentDataMap] = useState({});
  const [showZeroDaysModal, setShowZeroDaysModal] = useState(false);
  const [zeroDaysData, setZeroDaysData] = useState([]);
  const [zeroDaysMonth, setZeroDaysMonth] = useState('');
  const [showImportAlumnesModal, setShowImportAlumnesModal] = useState(false);
  const [dataRefreshKey, setDataRefreshKey] = useState(0);
  const rowsEmpty = datos.length === 0;

  useEffect(() => {
    // Fetch school data
    const fetchSchoolData = async () => {
      try {
        const response = await fetch( process.env.REACT_APP_API_URL + '/schools/');
        const data = await response.json();
        const schoolDataMap = data.reduce((acc, school) => {
          acc[school.CODI] = school.CENTRE;
          return acc;
        }, {});
        setSchoolData(schoolDataMap);
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    };

    const fetchStudentData = async () => {
      try {
        const response = await fetch( process.env.REACT_APP_API_URL + '/students/all');
        const data = await response.json();

        
        setStudentData(data);
        // const studentDataMap = data.reduce((acc, student) => {
        //   acc[student.CODI_BECARI] = {
        //     numSS: student.NUM_SS,
        //     fechaNacimiento: student.DATA_NAIXAMENT,
        //     fechaInicio: student.DATA_INICI,
        //     fechaFin: student.DATA_FINALITZACIO,
        //     checkInici: student.CHECK_TASCA_INICI,
        //     checkFinal: student.CHECK_TASCA_FINAL,
        //     obs: student.OBSERVACIONS_ALUMNE || '',
        //     gener: student.January,
        //     febrer: student.February,
        //     març: student.March,
        //     abril: student.April,
        //     maig: student.May,
        //     juny: student.June,
        //     juliol: student.July,
        //     agost: student.August,
        //     setembre: student.September,
        //     octubre: student.October,
        //     novembre: student.November,
        //     desembre: student.December
        //   };
        //   return acc;
        // }, {});
        const studentDataMap = data.reduce((acc, student) => {
          const key = `${student.CODI_CENTRE}_${student.CODI_BECARI}`;  // Clave única
          acc[key] = {
            numSS: student.NUM_SS,
            fechaNacimiento: student.DATA_NAIXAMENT,
            fechaInicio: student.DATA_INICI,
            fechaFin: student.DATA_FINALITZACIO,
            checkInici: student.CHECK_TASCA_INICI,
            checkFinal: student.CHECK_TASCA_FINAL,
            obs: student.OBSERVACIONS_ALUMNE || '',
            gener: student.January,
            febrer: student.February,
            març: student.March,
            abril: student.April,
            maig: student.May,
            juny: student.June,
            juliol: student.July,
            agost: student.August,
            setembre: student.September,
            octubre: student.October,
            novembre: student.November,
            desembre: student.December
          };
          return acc;
        }, {});

        
        setStudentDataMap(studentDataMap);
      } catch (error) {
        console.error('Error fetching student data:', error);
      }
    };

    fetchSchoolData();
    fetchStudentData();
  }, [dataRefreshKey]);

  // const exportToExcel = () => {
  // // Mapeo de los datos para incluir todos los campos del formulario
  //   const formattedData = datos.map(student => {
  //     const studentInfo = studentDataMap[student.DNI_NIE_PASSAPORT] || {}; // Acceder a la información adicional desde el studentDataMap
      
  //     // Formatear las fechas en formato día/mes/año
  //     const formattedFechaNacimiento = studentInfo.fechaNacimiento ? format(new Date(studentInfo.fechaNacimiento), 'dd-MM-yyyy') : '';
  //     const formattedDataInici = student.DATA_INICI ? format(new Date(student.DATA_INICI), 'dd-MM-yyyy') : '';
  //     const formattedDataFinalitzacio = student.DATA_FINALITZACIO ? format(new Date(student.DATA_FINALITZACIO), 'dd-MM-yyyy') : '';


  //     return {
  //       "Codi Becari": student.CODI_BECARI,
  //       "Codi Centre": student.CODI_CENTRE,
  //       "Cognoms Nom": student.COGNOMS_NOM,
  //       "DNI": student.DNI_NIE_PASSAPORT,
  //       "Numero Seguretat Social": studentInfo.numSS,
  //       "Data Naixament": formattedFechaNacimiento,
  //       "Inici Pràctiques": formattedDataInici,
  //       "Fi Pràctiques": formattedDataFinalitzacio,
  //       "Check Tasca Inici": student.CHECK_TASCA_INICI,
  //       "Check Tasca Final": student.CHECK_TASCA_FINAL
  //     };
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);
  //   const workbook = {
  //     Sheets: { 'Students': worksheet },
  //     SheetNames: ['Students']
  //   };
    
  //   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //   saveAs(data, 'students.xlsx');
  // };

  const exportToExcel = async () => {
  // Asegurarse de que 'datos' sea un array
  console.log("Datos en exportToExcel:", datos); // Verifica si OBSERVACIONS_ALUMNE está presente


  const formattedDatos = Array.isArray(datos) ? datos : []; // Asegura que datos sea un array
  
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Students');

  console.log("Contenido de datos:", formattedDatos);

  worksheet.columns = [
    { header: 'Codi Becari', key: 'CodiBecari', width: 15 },
    { header: 'Codi Centre', key: 'CodiCentre', width: 15 },
    { header: 'Cognoms Nom', key: 'CognomsNom', width: 50 },
    { header: 'DNI', key: 'DNI', width: 15 },
    { header: 'Numero Seguretat Social', key: 'NumSS', width: 25 },
    { header: 'Data Naixement', key: 'DataNaixament', width: 15 },
    { header: 'Inici Pràctiques', key: 'DataInici', width: 15 },
    { header: 'Fi Pràctiques', key: 'DataFinalitzacio', width: 15 },
    { header: 'Check Inici', key: 'CheckTascaInici', width: 15 },
    { header: 'Check Final', key: 'CheckTascaFinal', width: 15 },
    { header: 'Observacions', key: 'Observacions', width: 30 },
    { header: 'Gener', key: 'Gener', width: 10 },
    { header: 'Febrer', key: 'Febrer', width: 10 },
    { header: 'Març', key: 'Març', width: 10 },
    { header: 'Abril', key: 'Abril', width: 10 },
    { header: 'Maig', key: 'Maig', width: 10 },
    { header: 'Juny', key: 'Juny', width: 10 },
    { header: 'Juliol', key: 'Juliol', width: 10 },
    { header: 'Agost', key: 'Agost', width: 10 },
    { header: 'Setembre', key: 'Setembre', width: 10 },
    { header: 'Octubre', key: 'Octubre', width: 10 },
    { header: 'Novembre', key: 'Novembre', width: 10 },
    { header: 'Desembre', key: 'Desembre', width: 10 }
  ];

  // Estilo de cabecera
  worksheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFCC00' }
    };
    cell.font = { bold: true, color: { argb: 'FF0000FF' } };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
  });
  worksheet.getRow(1).height = 25; // Establece la altura de la cabecera a 25

  // Mapeo de datos formateados
  const formattedData = formattedDatos.map(student => {
    // const studentInfo = studentDataMap[student.CODI_BECARI] || {};
    const key = `${student.CODI_CENTRE}_${student.CODI_BECARI}`;
    const studentInfo = studentDataMap[key] || {};

    const formattedFechaNacimiento = studentInfo.fechaNacimiento ? format(new Date(studentInfo.fechaNacimiento), 'dd-MM-yyyy') : '';
    const formattedDataInici = student.DATA_INICI ? format(new Date(student.DATA_INICI), 'dd-MM-yyyy') : '';
    const formattedDataFinalitzacio = student.DATA_FINALITZACIO ? format(new Date(student.DATA_FINALITZACIO), 'dd-MM-yyyy') : '';

    return {
      CodiBecari: student.CODI_BECARI,
      CodiCentre: student.CODI_CENTRE,
      CognomsNom: student.COGNOMS_NOM,
      DNI: student.DNI_NIE_PASSAPORT,
      NumSS: studentInfo.numSS,
      DataNaixament: formattedFechaNacimiento,
      DataInici: formattedDataInici,
      DataFinalitzacio: formattedDataFinalitzacio,
      CheckTascaInici: student.CHECK_TASCA_INICI,
      CheckTascaFinal: student.CHECK_TASCA_FINAL,
      Observacions: studentInfo.obs || '',
      Gener: studentInfo.gener || 0,
      Febrer: studentInfo.febrer || 0,
      Març: studentInfo.març || 0,
      Abril: studentInfo.abril || 0,
      Maig: studentInfo.maig || 0,
      Juny: studentInfo.juny || 0,
      Juliol: studentInfo.juliol || 0,
      Agost: studentInfo.agost || 0,
      Setembre: studentInfo.setembre || 0,
      Octubre: studentInfo.octubre || 0,
      Novembre: studentInfo.novembre || 0,
      Desembre: studentInfo.desembre || 0
    };
  });

  // formattedData.forEach((data) => {
  //   worksheet.addRow(data);
  // });

    formattedData.forEach((data, index) => {
    const row = worksheet.addRow(data);
    row.height = 25; // Establece la altura de cada fila a 25
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blobData = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(blobData, 'students.xlsx');
};




  const exportToText = () => {
    let textData = '';
    // const filteredData = datos;
    const filteredData = Array.isArray(datos) ? datos : [];
    filteredData.forEach(student => {
      const tipoRegistro = '01'; // Tipo de registro: '01'
      const codigoEmpresa = (student.CODI_CENTRE || '').padStart(5, '0'); // Código de empresa
      const codigoTrabajo = (schoolData[student.CODI_CENTRE] || '').padStart(5, '0'); // Código de trabajo (centro)
      const codigoTrabajador = (student.CODI_BECARI || '').padStart(6, '0'); // Código de trabajador
      // const studentInfo = studentDataMap[student.CODI_BECARI] || {};
      const key = `${student.CODI_CENTRE}_${student.CODI_BECARI}`;
      const studentInfo = studentDataMap[key] || {};

      const dni = (student.DNI_NIE_PASSAPORT || '').padEnd(9, ' '); // DNI
      // const apellidosNombre = (student.COGNOMS_NOM || '').padEnd(30, ' '); // Apellidos y nombre
      const apellidosNombre = (student.COGNOMS_NOM || '')
    .replace(',', '') // Elimina la coma
    .split(' ') // Divide la cadena en palabras
    .filter(word => word) // Filtra elementos vacíos (por si hay más de un espacio)
    .join(' ') // Vuelve a unir las palabras con un espacio entre ellas
    .toUpperCase() // Convierte todo a mayúsculas
    .substring(0, 30) // Max 30 caracts
    .padEnd(30, ' '); // Rellena con espacios hasta 30 caracteres
      const numMatricula = '00000'; // Numero matricula
      // const numSS = (studentDataMap[student.CODI_BECARI] || '').padStart(12, '0'); // Número de Seguridad Social, ajustado a 12 caracteres con ceros a la izquierda
      const numSS = (studentInfo.numSS || '').padStart(12, '0');
      const padre = '.'.padEnd(15, ' ');
      const madre = '.'.padEnd(15, ' ');
      const hscl = 'HSCL'.padEnd(33, ' ');
      const numEscaleraPisoPuerta = '0000';
      const municipio = 'BARCELONA'.padEnd(20, ' ');
      const cp = '08000'.padEnd(15, '0');
      const clavePercepcion = 'A'.padEnd(8, '0');
      const tipoRetencion = 'A'.padEnd(21, '0');
      const codigoSerie = ''.padEnd(16, ' ');
      const becari = 'BECARI'.padStart(9, '0');
      const becari0 = 'BECARI'.padStart(10, ' ');
      const grupoTarifa = '0711301MNN'.padStart(12, ' ');
      const fechaNacimiento =  format(new Date(studentInfo.fechaNacimiento), 'yyyyMMdd').padStart(9, ' ');
      const fechaInicio =  format(new Date(studentInfo.fechaInicio), 'yyyyMMdd');
      const indicadorPluriempleado = 'N'.padEnd(31, '0');
      const indicadorTiempoParcial = 'D000000000000000N000000000000000000000000000000000000000000000000000000000000000000'.padStart(123, ' ');
      const horasAndTipoContrato = '000100'.padStart(36, ' ');
      const fechaFin =  format(new Date(studentInfo.fechaFin), 'yyyyMMdd');
      const nivelEstudiosTerminados = '53'.padEnd(11, ' ');
      const numContrato = '00000000000190001000000000000019000100 0000000000000000190001001900010000000000000000';
      const datosPagasExtras = '000000000'.padStart(14, ' ');
      const finalDescuadrado = '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000'.padStart(197, ' ');
      const finalDescuadrado1 = '00000000000000000072400000000000000000000000000000000000000000000000000000000    00   00  000000000000    0100'.padStart(410, ' ');
      const finalPredeterminado = '00000000000000                                          0801972400000000000003724                                                                                                                                                                                                                                                                   '.padStart(453, ' ');


      textData += `${tipoRegistro}${codigoEmpresa}${codigoTrabajo}${codigoTrabajador}${dni}${apellidosNombre}${numMatricula}${numSS}${padre}${madre}${hscl}${numEscaleraPisoPuerta}${municipio}${municipio}${cp}${clavePercepcion}${tipoRetencion}${codigoSerie}${becari}${becari0}${grupoTarifa}${fechaNacimiento}${fechaInicio}${numEscaleraPisoPuerta}${numEscaleraPisoPuerta}${fechaInicio}${fechaInicio}${indicadorPluriempleado}${indicadorTiempoParcial}${horasAndTipoContrato}${fechaInicio}${fechaFin}${nivelEstudiosTerminados}${numContrato}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${datosPagasExtras}${finalDescuadrado}${finalDescuadrado1}${finalPredeterminado}\n`;
    });

    const textBlob = new Blob([textData], { type: 'text/plain' });
    saveAs(textBlob, 'students.txt');
  };

  // Obre el modal amb stepper d'importació d'Alumnes
  const handleImportAlumnesClick = () => {
    setShowImportAlumnesModal(true);
  };

  // --------- Pas 1 del modal d'importació d'alumnes ---------
  // Llegeix i valida el fitxer Excel
  const handleAnalyzeAlumnesExcel = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const arrayBuffer = event.target.result;
          // const workbook = XLSX.read(arrayBuffer, { type: 'array' });
          // const sheetName = workbook.SheetNames[0];
          // const worksheet = workbook.Sheets[sheetName];

          // // Convertir la hoja a JSON con cellDates activado para reconocer fechas
          // const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false, cellDates: true }); 

          const workbook = XLSX.read(arrayBuffer, {
            type: 'array',
            cellDates: true, // Esto hace que SheetJS convierta números de serie a objetos Date
            dateNF: 'dd/mm/yyyy' // Formato de fecha esperado
          });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          // Convertir a JSON manteniendo fechas como objetos Date (blankrows: true evita que sheet_to_json descarte las filas vacías del Excel)
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            raw: false,
            dateNF: 'dd/mm/yyyy',
            blankrows: true
          });

          // Validar que el archivo contenga las columnas requeridas
          const requiredColumns = [
            'DNI NIE PASS',
            'COGNOM COGNOM NOM',
            'NÚMERO SS',
            'NÚMERO SS_1',
            'NÚMERO SS_2',
            'DATA NAIXEMENT',
            'INICI PRACTIQUES',
            'FI PRACTIQUES'
          ];
          const headers = new Set();
          jsonData.forEach(row => Object.keys(row).forEach(key => headers.add(key)));
          const missingColumns = requiredColumns.filter(col => !headers.has(col));

          if (missingColumns.length > 0) {
            reject(new Error('El fitxer no és vàlid.'));
            return;
          }

          // Calcula el número de fila real del Excel (idx + 2: la fila 1 es la cabecera) ANTES de descartar las filas vacías, para que la numeración no se descuadre
          const jsonDataWithRow = jsonData
            .map((student, idx) => ({ student, rowNumber: idx + 2 }))
            .filter(({ student }) =>
              Object.values(student).some(v => v !== undefined && v !== null && String(v).trim() !== '')
            );

          // Formatear cada estudiante
          const formattedStudents = jsonDataWithRow.map(({ student, rowNumber }) => {
            // Ajustar para coincidir con los nombres exactos de las columnas en el archivo Excel
            const ssPart1 = student['NÚMERO SS'] ? String(student['NÚMERO SS']).padStart(2, '0') : '00';
            const ssPart2 = student['NÚMERO SS_1'] ? String(student['NÚMERO SS_1']).padStart(8, '0') : '00000000';
            const ssPart3 = student['NÚMERO SS_2'] ? String(student['NÚMERO SS_2']).padStart(2, '0') : '00';

            // Concatenar las partes de la SS
            // student.SS = `${ssPart1} ${ssPart2} ${ssPart3}`.trim();

            student.SS = `${ssPart1}${ssPart2}${ssPart3}`.replace(/\s+/g, '');

            // Convertir fechas a formato ISO
            // student['DATA NAIXEMENT'] = formatDate(student['DATA NAIXEMENT']);
            // student['INICI PRACTIQUES'] = formatDate(student['INICI PRACTIQUES']);
            // student['FI PRACTIQUES'] = formatDate(student['FI PRACTIQUES']);

            // Guardem el valor original (abans de normalitzar) per poder validar el format de data a la fase 2
            student._RAW_DATA_NAIXEMENT = student['DATA NAIXEMENT'];
            student._RAW_INICI_PRACTIQUES = student['INICI PRACTIQUES'];
            student._RAW_FI_PRACTIQUES = student['FI PRACTIQUES'];

            student['DATA NAIXEMENT'] = formatDateSafe(student['DATA NAIXEMENT']);
            student['INICI PRACTIQUES'] = formatDateSafe(student['INICI PRACTIQUES']);
            student['FI PRACTIQUES'] = formatDateSafe(student['FI PRACTIQUES']);

            // Eliminar partes individuales de SS si no se necesitan
            delete student['NÚMERO SS'];
            delete student['NÚMERO SS_1'];
            delete student['NÚMERO SS_2'];

            student._EXCEL_ROW_NUMBER = rowNumber;

            return student;
          });

          // Validació de camps + CAS 1 / CAS 2, totes juntes en una única pantalla de previsualització
          const rows = buildImportPreviewRows(formattedStudents);
          resolve(rows);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  // --------- Pas 2 del modal d'importació d'alumnes ---------
  const MIN_NOM_LENGTH = 3;
  const MAX_NOM_LENGTH = 100;
  const MAX_DNI_LENGTH = 15;
  const currentYear = new Date().getFullYear();
  const hasInvalidNameChars = (value) => /[^A-Z ]/.test(value);

  // Detecta si una data en format text és inequívocament americana (mm/dd/yyyy). Objectes Date (cel·la de tipus data a Excel) mai es consideren ambigus.
  const isAmericanDateFormat = (rawValue) => {
    if (!(typeof rawValue === 'string') || !rawValue.includes('/')) return false;
    const parts = rawValue.split('/');
    if (parts.length !== 3) return false;
    const first = parseInt(parts[0], 10);
    const second = parseInt(parts[1], 10);
    // Només és inequívocament mm/dd si la segona part no pot ser un mes (>12) i la primera sí podria ser-ho
    return first <= 12 && second > 12;
  };

  // Valida camp per camp cada alumne de l'Excel
  const validateStudentFields = (students) => {
    return students
      .map((student, index) => {
        const errors = [];

        // Retalla espais en blanc al principi/final abans de validar, i guarda el valor ja net (un espai invisible pot fer que comparacions posteriors com la de duplicats fallin silenciosament)
        const trim = (value) => (typeof value === 'string' ? value.trim() : value);
        student['DNI NIE PASS'] = trim(student['DNI NIE PASS']);
        student['COGNOM COGNOM NOM'] = trim(student['COGNOM COGNOM NOM'])?.replace(/\s+/g, ' ');

        const dni = student['DNI NIE PASS'];
        const nom = student['COGNOM COGNOM NOM'];
        const dataNaixement = student['DATA NAIXEMENT'];
        const iniciPractiques = student['INICI PRACTIQUES'];
        const fiPractiques = student['FI PRACTIQUES'];

        // Camps buits
        if (!dni) errors.push('El camp DNI NIE PASS està buit');
        if (!nom) errors.push('El camp COGNOM COGNOM NOM està buit');
        if (!dataNaixement) errors.push('El camp DATA NAIXEMENT està buit');
        if (!iniciPractiques) errors.push('El camp INICI PRACTIQUES està buit');
        if (!fiPractiques) errors.push('El camp FI PRACTIQUES està buit');
        if (!student.SS) errors.push('El camp NÚMERO SS està buit');

        // DNI NIE PASS => majúscules, sense espais interns, format i lletra de control vàlids
        if (dni) {
          if (/\s/.test(dni)) {
            errors.push('El camp DNI NIE PASS no pot contenir espais');
          } else if (dni !== dni.toUpperCase()) {
            errors.push('El camp DNI NIE PASS ha d\'estar en majúscules');
          } else if (dni.length > MAX_DNI_LENGTH) {
            errors.push('El camp DNI NIE PASS té una longitud excessiva, reviseu el camp');
          }
        }

        // COGNOM COGNOM NOM => en majúscules i sense accents, caràcters vàlids i longitud raonable
        if (nom) {
          if (hasInvalidNameChars(nom)) {
            errors.push('El camp COGNOM COGNOM NOM només pot contenir lletres en majúscules i espais (sense accents, guions ni altres símbols)');
          }

          if (nom.length < MIN_NOM_LENGTH) {
            errors.push('El camp COGNOM COGNOM NOM és massa curt, reviseu si falten dades');
          } else if (nom.length > MAX_NOM_LENGTH) {
            errors.push('El camp COGNOM COGNOM NOM té una longitud excessiva, reviseu el camp');
          }
        }

        // NÚMERO SS (Codi d'afiliació) => només dígits, i ha de tenir 12 xifres
        if (student.SS && /[^\d]/.test(student.SS)) {
          errors.push('El camp NÚMERO SS no pot contenir lletres ni altres caràcters, només dígits');
        } else if (student.SS && !/^\d{12}$/.test(student.SS)) {
          errors.push('El camp NÚMERO SS  ha de tenir 12 dígits');
        }

        // INICI PRACTIQUES => l'any actual o el següent
        if (iniciPractiques) {
          const iniciYear = new Date(iniciPractiques).getFullYear();
          if (iniciYear !== currentYear && iniciYear !== currentYear + 1) {
            errors.push(`El camp INICI PRACTIQUES ha de ser de l'any ${currentYear} o ${currentYear + 1}`);
          }
        }

        // FI PRACTIQUES => l'any actual o el següent
        if (fiPractiques) {
          const fiYear = new Date(fiPractiques).getFullYear();
          if (fiYear !== currentYear && fiYear !== currentYear + 1) {
            errors.push(`El camp FI PRACTIQUES ha de ser de l'any ${currentYear} o ${currentYear + 1}`);
          }
        }

        // La data FI PRACTIQUES ha de ser posterior a la d'INICI PRACTIQUES
        if (iniciPractiques && fiPractiques && new Date(fiPractiques) < new Date(iniciPractiques)) {
          errors.push('El camp FI PRACTIQUES és anterior al camp INICI PRACTIQUES');
        }

        // Edat de l'alumne a l'inici de les pràctiques: mínim 16 anys, i descarta edats absurdes (>100 anys o naixement posterior a l'inici)
        if (dataNaixement && iniciPractiques) {
          const dNaixement = new Date(dataNaixement);
          const dInici = new Date(iniciPractiques);
          if (dNaixement > dInici) {
            errors.push('El camp DATA NAIXEMENT és posterior al camp INICI PRACTIQUES');
          } else {
            let edat = dInici.getFullYear() - dNaixement.getFullYear();
            const encaraNoFaAnys =
              dInici.getMonth() < dNaixement.getMonth() ||
              (dInici.getMonth() === dNaixement.getMonth() && dInici.getDate() < dNaixement.getDate());
            if (encaraNoFaAnys) edat -= 1;

            if (edat < 16) {
              errors.push('L\'alumne ha de tenir com a mínim 16 anys a l\'inici de les pràctiques');
            } else if (edat > 100) {
              errors.push('L\'edat de l\'alumne a l\'inici de les pràctiques supera els 100 anys, reviseu la data de naixement');
            }
          }
        }

        // Format de data no americà (mm/dd/yyyy)
        if (isAmericanDateFormat(student._RAW_DATA_NAIXEMENT)) errors.push('El camp DATA NAIXEMENT està en format americà (mm/dd/aaaa)');
        if (isAmericanDateFormat(student._RAW_INICI_PRACTIQUES)) errors.push('El camp INICI PRACTIQUES està en format americà (mm/dd/aaaa)');
        if (isAmericanDateFormat(student._RAW_FI_PRACTIQUES)) errors.push('El camp FI PRACTIQUES està en format americà (mm/dd/aaaa)');

        return { index, student, errors };
      })
      .filter(row => row.errors.length > 0);
  };

  // CAS 1 (vermell)
  const periodsOverlap = (startA, endA, startB, endB) => {
    if (!startA || !startB) return false;
    const sA = new Date(startA);
    const eA = endA ? new Date(endA) : null;
    const sB = new Date(startB);
    const eB = endB ? new Date(endB) : null;
    if (eA && sB > eA) return false;
    if (eB && sA > eB) return false;
    return true;
  };

  // CAS 2 (groc)
  const isMonthAdjacent = (iniciA, fiA, iniciB, fiB) => {
    if (!iniciA || !iniciB) return false;
    const dIniciA = new Date(iniciA);
    const dIniciB = new Date(iniciB);
    const nouInici = dIniciA >= dIniciB ? iniciA : iniciB;
    const anteriorFi = dIniciA >= dIniciB ? fiB : fiA;
    if (!anteriorFi) return false;
    const dNouInici = new Date(nouInici);
    const dAnteriorFi = new Date(anteriorFi);
    return dNouInici.getFullYear() === dAnteriorFi.getFullYear() && dNouInici.getMonth() === dAnteriorFi.getMonth();
  };

  // Classifica la comparació entre errors: CAS 1 (vermell) té prioritat sobre CAS 2 (groc)
  const classifyPeriods = (iniciA, fiA, iniciB, fiB) => {
    if (periodsOverlap(iniciA, fiA, iniciB, fiB)) return 'overlap';
    if (isMonthAdjacent(iniciA, fiA, iniciB, fiB)) return 'monthAdjacent';
    return 'none';
  };

  // Marca els alumnes segons CAS 1 (vermell) o CAS 2 (groc),
  // comparant-los amb tots els períodes ja existents del mateix DNI i amb la resta de files del mateix DNI dins del propi Excel
  const buildImportPreviewRows = (formattedStudents) => {
    // Errors de camp (buits, majúscules, format de data, any, SS...) per a cada fila
    const errorsByIndex = {};
    validateStudentFields(formattedStudents).forEach(row => {
      errorsByIndex[row.index] = row.errors;
    });

    // Un professor només es compara amb alumnes del seu propi centre
    const relevantStudentData = studentData.filter(s => s.ID_ESCOLA === datos[0]?.ID_ESCOLA)

    const existingByDni = relevantStudentData.reduce((acc, s) => {
      if (s.DNI_NIE_PASSAPORT) {
        if (!acc[s.DNI_NIE_PASSAPORT]) acc[s.DNI_NIE_PASSAPORT] = [];
        acc[s.DNI_NIE_PASSAPORT].push(s);
      }
      return acc;
    }, {});

    // Files del mateix fitxer agrupades per DNI, per poder-les comparar entre elles
    const fileGroupsByDni = {};
    formattedStudents.forEach((student, idx) => {
      const dni = student['DNI NIE PASS'];
      if (!fileGroupsByDni[dni]) fileGroupsByDni[dni] = [];
      fileGroupsByDni[dni].push({ student, rowNumber: student._EXCEL_ROW_NUMBER }); // número de fila REAL de l'Excel (calculat a handleAnalyzeAlumnesExcel, no descuadra si hi ha files buides)
    });

    return formattedStudents.map((student, index) => {
      const dni = student['DNI NIE PASS'];
      const inici = student['INICI PRACTIQUES'];
      const fi = student['FI PRACTIQUES']
      const errors = errorsByIndex[index] || [];

      // Conflictes detectats, separats per origen:
      // 'app'   -> ja existeix a l'aplicació (BBDD)
      // 'excel' -> una altra fila del mateix fitxer Excel
      const appConflicts = [];
      const excelConflicts = [];

      // Comparar contra tots els períodes ja existents en BBDD per aquest DNI (mateix centre)
      (existingByDni[dni] || []).forEach(existing => {
        const result = classifyPeriods(inici, fi, existing.DATA_INICI, existing.DATA_FINALITZACIO);
        if (result !== 'none') {
          appConflicts.push({
            type: result,
            source: 'app',
            codiBecari: existing.CODI_BECARI || null,
            nom: existing.COGNOMS_NOM || existing.NOM || null,
            inici: existing.DATA_INICI,
            fi: existing.DATA_FINALITZACIO
          });
        }
      });

      // Comparar contra la resta de files del mateix DNI dins del propi Excel
      (fileGroupsByDni[dni] || []).forEach(({ student: other, rowNumber }) => {
        if (other === student) return;
        const result = classifyPeriods(inici, fi, other['INICI PRACTIQUES'], other['FI PRACTIQUES']);
        if (result !== 'none') {
          excelConflicts.push({
            type: result,
            source: 'excel',
            rowNumber,
            nom: other['COGNOM COGNOM NOM'] || null,
            inici: other['INICI PRACTIQUES'],
            fi: other['FI PRACTIQUES']
          });
        }
      });

      const overlaps = [...appConflicts, ...excelConflicts].filter(c => c.type === 'overlap');
      const monthAdjacents = [...appConflicts, ...excelConflicts].filter(c => c.type === 'monthAdjacent');

      let category = 'none';
      let duplicateConflicts = [];
      if (overlaps.length > 0) {
        category = 'overlap';
        duplicateConflicts = overlaps;
      } else if (monthAdjacents.length > 0) {
        category = 'monthAdjacent';
        duplicateConflicts = monthAdjacents;
      }

      // Línia(es) de l'Excel on s'ha trobat el/els duplicat(s) dins del propi fitxer
      const duplicateExcelRows = [
        ...new Set(
          duplicateConflicts
            .filter(c => c.source === 'excel')
            .map(c => c.rowNumber)
        )
      ].sort((a, b) => a - b);

      // Codi(s) de becari del/dels alumne(s) ja existent(s) a l'aplicació amb qui xoca
      const duplicateCodisBecari = [
        ...new Set(
          duplicateConflicts
            .filter(c => c.source === 'app')
            .map(c => c.codiBecari)
            .filter(Boolean)
        )
      ];
      
      return {
        student,
        excelRowNumber: student._EXCEL_ROW_NUMBER, // número de fila REAL de l'Excel, no es descuadra encara que hi hagi files buides pel mig
        category,
        duplicateConflicts, // detall dels conflictes concrets (origen, fila/codi becari, dates)
        duplicateExcelRows, // núm. de fila(es) de l'Excel amb qui hi ha conflicte
        duplicateCodisBecari, // codi(s) de becari de l'aplicació amb qui hi ha conflicte
        errors,
      };
    });
  };

  // --------- Pas 3 del modal d'importació d'alumnes ---------
  // Importar
  const handleConfirmImportAlumnes = async (analyzedStudents) => {
    const result = await uploadStudents(analyzedStudents);
    if (result) {
      return { ...result };
    }
    return null;
  };




// Afegir 0 al format String de dates (Canvi 8/10/2025 per escola que s'importen malament les dates)
// const normalizeDateString = (dateStr) => {
//   if (typeof dateStr !== 'string') return dateStr;

//   // Acepta formatos como "7/9/2025" o "07/9/2025"
//   const match = dateStr.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
//   if (!match) return dateStr; // no coincide

//   const [, d, m, y] = match;
//   const day = d.padStart(2, '0');
//   const month = m.padStart(2, '0');
//   const year = y.length === 2 ? `20${y}` : y;

//   return `${day}/${month}/${year}`;
// };



// Per format antic de Excel importacio (Date)i nou amb amb (String)
// const formatDate = (date) => {
//   if (!date) return '';

//   // 🔹 NUEVA plantilla: texto dd/mm/yyyy → lo tratamos como día/mes fijo
//   if (typeof date === 'string' && date.includes('/')) {
//     const parts = date.split('/');
//     if (parts.length === 3) {
//       const [day, month, year] = parts;
//       return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//     }
//   }

//   // 🔹 ANTIGUA plantilla: objeto Date → mantenemos la lógica original
//   if (date instanceof Date) {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   }

//   // 🔹 Si viene de la antigua plantilla girada (texto tipo mm/dd/yyyy)
//   if (typeof date === 'string' && date.includes('-')) {
//     const parts = date.split('-');
//     if (parts.length === 3) {
//       let day, month, year;
//       if (parseInt(parts[0], 10) > 12) {
//         // dd-mm-yyyy
//         [day, month, year] = parts;
//       } else {
//         // mm-dd-yyyy
//         [month, day, year] = parts;
//       }
//       return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//     }
//   }

//   return '';
// };



// const formatDate = (date) => {
//   if (!date) return '';

//   // 🔹 Caso 1: Viene como texto "dd/mm/yyyy" o "mm/dd/yyyy"
//   if (typeof date === 'string' && date.includes('/')) {
//     const parts = date.split('/').map(p => p.trim());
//     if (parts.length === 3) {
//       const [a, b, c] = parts;
//       const year = c.length === 2 ? `20${c}` : c;

//       // Si el primer número > 12 → seguro que es el día
//       if (parseInt(a, 10) > 12) {
//         return `${year}-${b.padStart(2, '0')}-${a.padStart(2, '0')}`;
//       }
//       // Si el segundo número > 12 → seguro que es el mes (caso americano)
//       if (parseInt(b, 10) > 12) {
//         return `${year}-${a.padStart(2, '0')}-${b.padStart(2, '0')}`;
//       }
//       // Si ambos <= 12 → no hay forma de saberlo con certeza
//       // asumimos dd/mm/yyyy (por ser el formato estándar aquí)
//       return `${year}-${b.padStart(2, '0')}-${a.padStart(2, '0')}`;
//     }
//   }

//   // 🔹 Caso 2: Viene como objeto Date (Excel Date)
//   if (date instanceof Date && !isNaN(date)) {
//     const year = date.getFullYear();
//     let month = date.getMonth() + 1;
//     let day = date.getDate();

//     // 🧩 Detección automática de fechas giradas (ambiguas)
//     // Solo si día y mes son <= 12
//     if (day <= 12 && month <= 12 && day !== month) {
//       const flipped = new Date(year, day - 1, month);
//       const diffOriginal = Math.abs(new Date() - date);
//       const diffFlipped = Math.abs(new Date() - flipped);

//       // Si la girada está más cerca de hoy o parece más razonable
//       if (diffFlipped < diffOriginal) {
//         [day, month] = [month, day];
//       }
//     }

//     return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
//   }

//   return '';
// };





//  Versión final (no gira fechas, formato dd/mm/yyyy garantizado)
// const formatDate = (date) => {
//   if (!date) return '';

//   if (typeof date === 'string' && date.includes('/')) {
//     const parts = date.split('/');
//     if (parts.length === 3) {
//       const [day, month, year] = parts.map((p) => p.trim());
//       return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//     }
//   } else if (date instanceof Date && !isNaN(date)) {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   }

//   return date;
// };

// Función mejorada para manejar fechas
const formatDateSafe = (dateValue) => {
  // Si ya es un objeto Date (viene de Excel como fecha)
  if (dateValue instanceof Date && !isNaN(dateValue)) {
    const year = dateValue.getFullYear();
    const month = String(dateValue.getMonth() + 1).padStart(2, '0');
    const day = String(dateValue.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  // Si es un número (número de serie de Excel)
  if (typeof dateValue === 'number') {
    const date = XLSX.SSF.parse_date_code(dateValue);
    const year = date.y;
    const month = String(date.m).padStart(2, '0');
    const day = String(date.d).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  // Si es string con formato dd/mm/yyyy o mm/dd/yyyy
  if (typeof dateValue === 'string' && dateValue.includes('/')) {
    const parts = dateValue.split('/');
    if (parts.length === 3) {
      let day, month, year;
      
      // Detectar formato basándose en múltiples criterios
      const firstNum = parseInt(parts[0], 10);
      const secondNum = parseInt(parts[1], 10);
      
      // Si el primer número es claramente un día (>12)
      if (firstNum > 12) {
        [day, month, year] = parts;
      }
      // Si el segundo número es claramente un día (>12)
      else if (secondNum > 12) {
        [month, day, year] = parts;
      }
      // Caso ambiguo: asumir formato europeo dd/mm/yyyy (tu formato esperado)
      else {
        [day, month, year] = parts;
      }
      
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }

  // Si es string con formato dd-mm-yyyy o mm-dd-yyyy
  if (typeof dateValue === 'string' && dateValue.includes('-')) {
    const parts = dateValue.split('-');
    if (parts.length === 3) {
      let day, month, year;
      const firstNum = parseInt(parts[0], 10);
      const secondNum = parseInt(parts[1], 10);

      if (firstNum > 12) {
        [day, month, year] = parts;
      } else if (secondNum > 12) {
        [month, day, year] = parts;
      } else {
        [day, month, year] = parts;
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
  
  return dateValue; // Devolver sin cambios si no se puede procesar
};

//  EX bona
// const formatDate = (date) => {
//   if (typeof date === 'string' && date.includes('/')) {
//     const parts = date.split('/');
//     if (parts.length === 3) {
//       let day, month, year;
//       if (parseInt(parts[0], 10) > 12) {
//         // dd/mm/yyyy
//         [day, month, year] = parts;
//       } else {
//         // mm/dd/yyyy
//         [month, day, year] = parts;
//       }
//       return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//     }
//   } else if (date instanceof Date) {
//     // Si es un objeto Date
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   }
//   return date; // Si el valor no es reconocible, devolver como está
// };



// const formatDate = (value) => {
//   if (value instanceof Date) {
//     // Si ya es objeto Date
//     const year = value.getFullYear();
//     const month = String(value.getMonth() + 1).padStart(2, '0');
//     const day = String(value.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   }

//   // Si viene como número (Excel date serial)
//   if (typeof value === 'number') {
//     const excelEpoch = new Date(1899, 11, 30); // Excel epoch
//     const date = new Date(excelEpoch.getTime() + value * 86400000);
//     return formatDate(date); // Recursivamente
//   }

//   // Si viene como string (tipo "dd/mm/yyyy" o "mm/dd/yyyy")
//   if (typeof value === 'string' && value.includes('/')) {
//     const parts = value.split('/');
//     if (parts.length === 3) {
//       let day, month, year;

//       if (parseInt(parts[0], 10) > 12) {
//         // dd/mm/yyyy
//         [day, month, year] = parts;
//       } else if (parseInt(parts[1], 10) > 12) {
//         // mm/dd/yyyy
//         [month, day, year] = parts;
//       } else {
//         // Ambiguo, forzamos formato español
//         [day, month, year] = parts;
//       }

//       return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//     }
//   }

//   return value; // Devuelve tal cual si no es interpretable
// };



const handleFileUploadPracts = (event) => {
  const selectedFile = event.target.files[0];
  setFile(selectedFile);
  readExcelFilePracts(selectedFile);
};

const readExcelFilePracts = (file) => {
  const reader = new FileReader();
  reader.onload = (event) => {
    const arrayBuffer = event.target.result;
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
   //  const jsonData = XLSX.utils.sheet_to_json(worksheet);
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: 0 });
// Validar columnes requerides
    const requiredColumns = [
      'CODI BECARI',
      'DNI NIE PASS',
      'NOM',
      'INICI PRACTIQUES',
      'FI PRACTIQUES',
      'GENER',
      'FEBRER',
      'MARÇ',
      'ABRIL',
      'MAIG',
      'JUNY',
      'JULIOL',
      'AGOST',
      'SETEMBRE',
      'OCTUBRE',
      'NOVEMBRE',
      'DESEMBRE'
    ];
    const headers = Object.keys(jsonData[0] || {});
    const missingColumns = requiredColumns.filter(col => !headers.includes(col));

    if (missingColumns.length > 0) {
      toast.error(`El fitxer no és vàlid`);
      return;
    }


    console.log(jsonData);
    uploadPractices(jsonData);
  };
  reader.readAsArrayBuffer(file);
};

const uploadStudents = async (students) => {
  try {
    const formattedStudents = students.map(student => ({
      // NOM: student.NOM,
      // COGNOM: student.COGNOMS,
      // NOM: student["COGNOMS NOM"],
      NOM: student["COGNOM COGNOM NOM"],
      DNI: student["DNI NIE PASS"],
      DATA_NAIXAMENT: student['DATA NAIXEMENT'],
      NUM_SS: student.SS, // Usamos el valor concatenado de la SS
      INICI_PRACTIQUES: student['INICI PRACTIQUES'],
      FI_PRACTIQUES: student['FI PRACTIQUES']
    }));

    const url = user.role_id === 1
      ? `${process.env.REACT_APP_API_URL}/import/massImport/${user.id}`
      : `${process.env.REACT_APP_API_URL}/import/massImport`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ students: formattedStudents }),
    });

    const result = await response.json();

    if (response.ok) {
      const { successCount, errorDetails } = result;
      onSuccess(); // Llama a la función de éxito para actualizar la tabla
      setDataRefreshKey(prev => prev + 1); // re-fetch studentData → detecta duplicats actualitzats
      return { successCount, errorDetails: errorDetails || [] };
    }

    toast.error('Error al importar los alumnos');
    return null;
  } catch (error) {
    console.error('Error importing students:', error);
    toast.error('Error al importar els alumnes');
    return null;
  }
};
const uploadPractices = async (practices) => {
  try {
    const catMonthKeys = ['GENER', 'FEBRER', 'MARÇ', 'ABRIL', 'MAIG', 'JUNY', 'JULIOL', 'AGOST', 'SETEMBRE', 'OCTUBRE', 'NOVEMBRE', 'DESEMBRE'];
    const catMonthLabels = ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'];
    const prevMonthIdx = new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1;
    const prevMonthKeyCat = catMonthKeys[prevMonthIdx];
    const prevMonthLabel = catMonthLabels[prevMonthIdx];
    // Compute target month date range to filter only students with active practices
    const now = new Date();
    const prevYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
    const targetStart = new Date(prevYear, prevMonthIdx, 1);
    const targetEnd = new Date(prevYear, prevMonthIdx + 1, 0); // last day of month

    const zeroDayStudents = practices.filter(practice => {
      if (practice[prevMonthKeyCat] && Number(practice[prevMonthKeyCat]) !== 0) return false;
      // Cross-reference with studentData to check practice dates cover the target month
      const codiBecari = practice['CODI BECARI'];
      const match = studentData.find(s => s.CODI_BECARI === codiBecari);
      if (match) {
        const inici = new Date(match.DATA_INICI);
        const fi = match.DATA_FINALITZACIO ? new Date(match.DATA_FINALITZACIO) : null;
        if (inici > targetEnd) return false;
        if (fi && fi < targetStart) return false;
      }
      return true;
    });

    const formattedPractices = practices.map(practice => {
      return {
        CODI_BECARI: practice["CODI BECARI"],
        DNI: practice["DNI NIE PASS"], // new 24-03-2025
        GENER: practice.GENER,
        FEBRER: practice.FEBRER,
        MARÇ: practice.MARÇ,
        ABRIL: practice.ABRIL,
        MAIG: practice.MAIG,
        JUNY: practice.JUNY,
        JULIOL: practice.JULIOL,
        AGOST: practice.AGOST,
        SETEMBRE: practice.SETEMBRE,
        OCTUBRE: practice.OCTUBRE,
        NOVEMBRE: practice.NOVEMBRE,
        DESEMBRE: practice.DESEMBRE
      };
    });

    const url = user.role_id === 1
      ? process.env.REACT_APP_API_URL + `/import/practices/${user.id}`
      : process.env.REACT_APP_API_URL + '/import/practices';

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ practices: formattedPractices }),
    });

    const result = await response.json();

    if (response.ok) {
      const { successCount, failedPractices } = result;
      onSuccessPracts();
      setDataRefreshKey(prev => prev + 1); // re-fetch studentData → updates orange counter
      toast.success(`${successCount} pràctiques importades correctament!`);

      if (failedPractices && failedPractices.length > 0) {
        failedPractices.forEach(detail => {
          toast.error(`Error al importar la pràctica de ${detail.practice.CODI_BECARI}: ${detail.error}`);
        });
      }

      if (zeroDayStudents.length > 0) {
        setZeroDaysData(zeroDayStudents);
        setZeroDaysMonth(prevMonthLabel);
        setShowZeroDaysModal(true);
      }
    } else {
      toast.error('Error al importar les pràctiques');
    }
  } catch (error) {
    console.error('Error importing practices:', error);
    toast.error('Error al importar les pràctiques');
  }
};

const downloadZeroDaysReport = async (zeroDayStudents) => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Alumnes 0 dies');

    worksheet.columns = [
      { header: 'CODI BECARI', key: 'CODI_BECARI', width: 15 },
      { header: 'DNI NIE PASS', key: 'DNI', width: 15 },
      { header: 'NOM', key: 'NOM', width: 35 },
      { header: 'INICI PRACTIQUES', key: 'INICI', width: 18 },
      { header: 'FI PRACTIQUES', key: 'FI', width: 18 },
      { header: 'GENER', key: 'GENER', width: 10 },
      { header: 'FEBRER', key: 'FEBRER', width: 10 },
      { header: 'MARÇ', key: 'MARC', width: 10 },
      { header: 'ABRIL', key: 'ABRIL', width: 10 },
      { header: 'MAIG', key: 'MAIG', width: 10 },
      { header: 'JUNY', key: 'JUNY', width: 10 },
      { header: 'JULIOL', key: 'JULIOL', width: 10 },
      { header: 'AGOST', key: 'AGOST', width: 10 },
      { header: 'SETEMBRE', key: 'SETEMBRE', width: 12 },
      { header: 'OCTUBRE', key: 'OCTUBRE', width: 12 },
      { header: 'NOVEMBRE', key: 'NOVEMBRE', width: 12 },
      { header: 'DESEMBRE', key: 'DESEMBRE', width: 12 },
    ];

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF0000' } };
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    zeroDayStudents.forEach(student => {
      worksheet.addRow({
        CODI_BECARI: student["CODI BECARI"],
        DNI: student["DNI NIE PASS"],
        NOM: student.NOM,
        INICI: student["INICI PRACTIQUES"],
        FI: student["FI PRACTIQUES"],
        GENER: student.GENER || 0,
        FEBRER: student.FEBRER || 0,
        MARC: student['MARÇ'] || 0,
        ABRIL: student.ABRIL || 0,
        MAIG: student.MAIG || 0,
        JUNY: student.JUNY || 0,
        JULIOL: student.JULIOL || 0,
        AGOST: student.AGOST || 0,
        SETEMBRE: student.SETEMBRE || 0,
        OCTUBRE: student.OCTUBRE || 0,
        NOVEMBRE: student.NOVEMBRE || 0,
        DESEMBRE: student.DESEMBRE || 0,
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const today = format(new Date(), 'dd-MM-yyyy');
    saveAs(blobData, `Alumnes_0_dies_practiques_${today}.xlsx`);
  } catch (error) {
    console.error('Error generant el report de 0 dies:', error);
  }
};


const downloadTemplate = async () => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Plantilla Alumnes');

    // Definir columnas con encabezados, claves y ancho
    worksheet.columns = [
      { header: 'DNI NIE PASS', key: 'DNI NIE PASS', width: 20 },
      // { header: 'COGNOMS', key: 'COGNOMS', width: 30 },
      // { header: 'NOM', key: 'NOM', width: 30 },
      // { header: 'COGNOMS NOM', key: 'COGNOMS NOM', width: 45 },
      { header: 'COGNOM COGNOM NOM', key: 'COGNOMS NOM', width: 45 },
      { header: 'NÚMERO SS', key: 'ss_part1', width: 20 },
      { header: 'NÚMERO SS', key: 'ss_part2', width: 20 },
      { header: 'NÚMERO SS', key: 'ss_part3', width: 20 },
      { header: 'DATA NAIXEMENT', key: 'DATA NAIXEMENT', width: 20 },
      { header: 'INICI PRACTIQUES', key: 'INICI PRACTIQUES', width: 20 },
      { header: 'FI PRACTIQUES', key: 'FI PRACTIQUES', width: 20 }
      // { header: 'NÚMERO SS', key: 'ss_part1', width: 20 },
      // { header: 'NÚMERO SS', key: 'ss_part2', width: 20 },
      // { header: 'NÚMERO SS', key: 'ss_part3', width: 20 }
    ];

    worksheet.eachRow((row) => {
      row.height = 25; // Altura específica para todas las filas
    });

    // Estilos para la cabecera
    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFCC00' }
      };
      cell.font = { bold: true, color: { argb: 'FF0000FF' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    const numRows = 100; // Aplica validaciones hasta la fila 100, puedes ajustar según necesidad

    const namedni = ['A'];
    namedni.forEach((col) => {
      for (let i = 2; i <= numRows; i++) {
        const cell = worksheet.getCell(`${col}${i}`);

        // Configurar la validación para solo letras
        cell.dataValidation = {
        type: 'textLength',
        operator: 'equal',
        formulae: [9],
        showErrorMessage: true,
        errorTitle: 'Valor inválido',
        error: 'Debe ser un DNI, NIE o pasaporte válido de 9 caracteres.'
        };
        // cell.numFmt = '@';

        // Opcional: Agrega una nota para guiar al usuario
        cell.note = 'En caso de DNI: 12345678Z || En caso de NIE: X1234567L || En caso de PASSAPORTE: E12345678';
      }
    });

  // const nameColumns = ['B'];
  //   nameColumns.forEach((col) => {
  //     for (let i = 2; i <= numRows; i++) {
  //       const cell = worksheet.getCell(`${col}${i}`);

  //       // Configurar la validación para solo letras
  //       cell.dataValidation = {
  //         // type: 'custom',
  //         // formulae: `ISTEXT(${col}${i})`, // Verifica que el valor sea texto
  //         allowBlank: false, // No permite celdas en blanco
  //         showErrorMessage: true,
  //         errorTitle: 'Valor inválido',
  //         error: 'Solo se permiten letras en este campo.'
  //       };
  //       cell.numFmt = '@';

  //       // Opcional: Agrega una nota para guiar al usuario
  //       cell.note = 'Por favor, ingresa apellidos y nombre en ese orden';
  //     }
  // });

  const nameColumns = ['B'];
nameColumns.forEach((col) => {
  for (let i = 2; i <= numRows; i++) {
    const cell = worksheet.getCell(`${col}${i}`);

    // Validación para no permitir acentos, diéresis ni la letra Ñ
    cell.dataValidation = {
      type: 'custom',
      formulae: [
        `ISERROR(FIND("á", ${col}${i})) * ISERROR(FIND("à", ${col}${i})) *
         ISERROR(FIND("é", ${col}${i})) * ISERROR(FIND("è", ${col}${i})) *
         ISERROR(FIND("í", ${col}${i})) * ISERROR(FIND("ì", ${col}${i})) *
         ISERROR(FIND("ó", ${col}${i})) * ISERROR(FIND("ò", ${col}${i})) *
         ISERROR(FIND("ú", ${col}${i})) * ISERROR(FIND("ù", ${col}${i})) *
         ISERROR(FIND("Á", ${col}${i})) * ISERROR(FIND("À", ${col}${i})) *
         ISERROR(FIND("É", ${col}${i})) * ISERROR(FIND("È", ${col}${i})) *
         ISERROR(FIND("Í", ${col}${i})) * ISERROR(FIND("Ì", ${col}${i})) *
         ISERROR(FIND("Ó", ${col}${i})) * ISERROR(FIND("Ò", ${col}${i})) *
         ISERROR(FIND("Ú", ${col}${i})) * ISERROR(FIND("Ù", ${col}${i})) *
         ISERROR(FIND("ü", ${col}${i})) * ISERROR(FIND("Ü", ${col}${i})) *
         ISERROR(FIND("ñ", ${col}${i})) * ISERROR(FIND("Ñ", ${col}${i}))`
      ],
      allowBlank: false,
      showErrorMessage: true,
      errorTitle: 'Caracteres no permitidos',
      error: 'No se permiten letras con tilde, diéresis ni la letra Ñ.',
    };

    // Formato de celda como texto
    cell.numFmt = '@'; // Esto obliga a Excel a tratar el valor como texto, no como número o fórmula.

    // Nota para el usuario
    cell.note = 'Por favor, escribe los apellidos seguidos del nombre (sin tildes ni Ñ). Ejemplo: GARCIA LOPEZ JUAN';
  }
});


    // Validación para "DATA NAIXAMENT", "INICI PRACTIQUES" y "FI PRACTIQUES" - formato de fecha
    const dateColumns = ['F', 'G', 'H'];
    dateColumns.forEach((col) => {
      for (let i = 2; i <= numRows; i++) {
        const cell = worksheet.getCell(`${col}${i}`);

        // Aplicar validación de fecha estricta
        cell.dataValidation = {
          type: 'date',
          operator: 'greaterThan',
          formulae: [new Date(1901, 0, 1)],  // Fecha mínima permitida
          showErrorMessage: true,
          errorTitle: 'Fecha inválida',
          error: 'Por favor, ingresa una fecha válida después del 01/01/2016 en formato dd/mm/aaaa.'
        };
        cell.note = 'Por favor, ingresa la fecha en formato dd/mm/aaaa';
      }
    });

// const dateColumns = ['F', 'G', 'H'];
// dateColumns.forEach((col) => {
//   for (let i = 2; i <= numRows; i++) {
//     const cell = worksheet.getCell(`${col}${i}`);

//     // ✅ Formato texto para que Excel no gire el día y mes
//     cell.numFmt = '@';

//     // ✅ Validación básica: tiene que tener dos "/" y números en las partes
//     cell.dataValidation = {
//       type: 'custom',
//       formulae: [
//         `AND(
//           ISNUMBER(VALUE(SUBSTITUTE(${col}${i},"/",""))),
//           LEN(${col}${i})>=8,
//           ISNUMBER(SEARCH("/", ${col}${i}))
//         )`
//       ],
//       showErrorMessage: true,
//       errorTitle: 'Formato incorrecto',
//       error: 'Por favor, escribe una fecha numérica con barras (por ejemplo, 7/10/2025 o 07/10/2025).',
//     };

//     // ✅ Nota explicativa
//     cell.note = 'Introduce la fecha en formato dd/mm/aaaa. Ejemplo: 07/10/2025 o 7/10/2025';
//   }
// });



    for (let i = 2; i <= numRows; i++) {
  // Validación y nota para columna G
      const cellG = worksheet.getCell(`C${i}`);
      cellG.dataValidation = {
        type: 'whole',
        operator: 'between',
        formulae: [0, 99],
        showErrorMessage: true,
        errorTitle: 'Valor inválido',
        error: 'Ingresa un número entre 00 y 99 en formato de dos dígitos.'
      };
      cellG.note = 'Por favor, ingresa los 2 primeros digitos del Número de la Seguridad Social';

      // Validación y nota para columna H
      const cellH = worksheet.getCell(`D${i}`);
      cellH.dataValidation = {
        type: 'whole',
        operator: 'between',
        formulae: [0, 99999999],
        showErrorMessage: true,
        errorTitle: 'Valor inválido',
        error: 'Ingresa un número en formato de ocho dígitos.'
      };
      cellH.note = 'Por favor, ingresa los 8 digitos siguientes del Número de la Seguridad Social';
      
      // Validación y nota para columna I
      const cellI = worksheet.getCell(`E${i}`);
      cellI.dataValidation = {
        type: 'whole',
        operator: 'between',
        formulae: [0, 99],
        showErrorMessage: true,
        errorTitle: 'Valor inválido',
        error: 'Ingresa un número entre 00 y 99 en formato de dos dígitos.'
      };
      cellI.note = 'Por favor, ingresa los 2 últimos digitos del Número de la Seguridad Social';
    }

    // Configuración de formato para cada columna
    worksheet.getColumn('ss_part3').numFmt = '00';
    worksheet.getColumn('ss_part2').numFmt = '00000000';
    worksheet.getColumn('ss_part1').numFmt = '00';

    // Validación para Seguridad Social: longitud exacta
    // for (let i = 2; i <= numRows; i++) {
    //   worksheet.getCell(`G${i}`).dataValidation = {
    //     type: 'whole',
    //     operator: 'between',
    //     formulae: [0, 99],
    //     showErrorMessage: true,
    //     errorTitle: 'Valor inválido',
    //     error: 'Ingresa un número entre 00 y 99 en formato de dos dígitos.'
    //   };
    //   worksheet.getCell(`H${i}`).dataValidation = {
    //     type: 'whole',
    //     operator: 'between',
    //     formulae: [0, 99999999],
    //     showErrorMessage: true,
    //     errorTitle: 'Valor inválido',
    //     error: 'Ingresa un número entre 00 y 99 en formato de dos dígitos.'
    //   };
    //   worksheet.getCell(`I${i}`).dataValidation = {
    //     type: 'whole',
    //     operator: 'between',
    //     formulae: [0, 99],
    //     showErrorMessage: true,
    //     errorTitle: 'Valor inválido',
    //     error: 'Ingresa un número entre 00 y 99 en formato de dos dígitos.'
    //   };

    //   worksheet.getColumn('ss_part3').numFmt = '00';
    //   worksheet.getColumn('ss_part2').numFmt = '00000000';
    //   worksheet.getColumn('ss_part1').numFmt = '00';

    // }

    // Generar el archivo Excel y descargarlo
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blobData, 'Plantilla_Alumnes.xlsx');
  } catch (error) {
    console.error('Error al descargar la plantilla:', error);
  }
};




  const monthKeysEN = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const monthLabelsCat = ['Gener','Febrer','Març','Abril','Maig','Juny','Juliol','Agost','Setembre','Octubre','Novembre','Desembre'];

  // Role 1: always check previous month automatically
  // Role 2: only check when 'dades creuades' filter is active (activeMonthKey set)
  const targetMonthKey = user.role_id === 2
    ? activeMonthKey  // null if dades creuades not active
    : monthKeysEN[new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1];

  const targetMonthLabel = targetMonthKey
    ? monthLabelsCat[monthKeysEN.indexOf(targetMonthKey)]
    : null;

  const zeroDaysFromTable = (() => {
    if (!targetMonthKey) return []; // Role 2 without active dades creuades → hide
    const visibleIds = new Set(datos.map(d => d.ID_ALUMNES));

    // For Role 1: compute the target month date range so we only count students
    // whose practice period actually covers that month
    let targetMonthStart = null;
    let targetMonthEnd = null;
    if (user.role_id !== 2) {
      const now = new Date();
      const prevIdx = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
      const prevYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
      targetMonthStart = new Date(prevYear, prevIdx, 1);
      targetMonthEnd = new Date(prevYear, prevIdx + 1, 0); // last day of month
    }

    return studentData.filter(s => {
      if (!visibleIds.has(s.ID_ALUMNES)) return false;
      if (s.DATA_INICI == null) return false;
      if (!(s[targetMonthKey] === 0 || s[targetMonthKey] === null || s[targetMonthKey] === undefined)) return false;

      // Role 1: verify the student's practice dates overlap with the target month
      if (targetMonthStart && targetMonthEnd) {
        const inici = new Date(s.DATA_INICI);
        const fi = s.DATA_FINALITZACIO ? new Date(s.DATA_FINALITZACIO) : null;
        // Practice must have started before or during the target month
        if (inici > targetMonthEnd) return false;
        // Practice must end during or after the target month (if fi exists)
        if (fi && fi < targetMonthStart) return false;
      }

      return true;
    });
  })();

  const downloadZeroDaysFromTable = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Alumnes 0 dies');

      if (user.role_id === 2) {
        // ── Role 2 (superadmin): student columns + the single filtered month only ──
        worksheet.columns = [
          { header: 'CODI BECARI',      key: 'CODI',  width: 14 },
          { header: 'DNI NIE PASS',     key: 'DNI',   width: 15 },
          { header: 'NOM',              key: 'NOM',   width: 35 },
          { header: 'INICI PRACTIQUES', key: 'INICI', width: 18 },
          { header: 'FI PRACTIQUES',    key: 'FI',    width: 18 },
          { header: targetMonthLabel || 'MES', key: 'MES', width: 10 },
        ];

        // Header row styling — orange base, red on the month column (col 6)
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: colNumber === 6 ? 'FFCC0000' : 'FFFF6600' } };
          cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
        });
        worksheet.getRow(1).height = 22;

        zeroDaysFromTable.forEach(s => {
          const row = worksheet.addRow({
            CODI:  s.CODI_BECARI,
            DNI:   s.DNI_NIE_PASSAPORT || s.DNI,
            NOM:   s.COGNOMS_NOM || s.NOM,
            INICI: s.DATA_INICI ? format(new Date(s.DATA_INICI), 'dd/MM/yyyy') : '',
            FI:    s.DATA_FINALITZACIO ? format(new Date(s.DATA_FINALITZACIO), 'dd/MM/yyyy') : '',
            MES:   targetMonthKey ? (s[targetMonthKey] || 0) : 0,
          });
          row.height = 22;
          // Highlight the month value cell (col 6) in light red
          const monthCell = row.getCell(6);
          monthCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFCCCC' } };
          monthCell.font = { bold: true };
        });

      } else {
        // ── Role 1 (school admin): all 12 months with target month highlighted ──
        worksheet.columns = [
          { header: 'CODI BECARI',      key: 'CODI', width: 14 },
          { header: 'DNI NIE PASS',     key: 'DNI',  width: 15 },
          { header: 'NOM',              key: 'NOM',  width: 35 },
          { header: 'INICI PRACTIQUES', key: 'INICI', width: 18 },
          { header: 'FI PRACTIQUES',    key: 'FI',   width: 18 },
          { header: 'GENER',    key: 'G',  width: 9 },
          { header: 'FEBRER',   key: 'F',  width: 9 },
          { header: 'MARÇ',     key: 'MA', width: 9 },
          { header: 'ABRIL',    key: 'AB', width: 9 },
          { header: 'MAIG',     key: 'MG', width: 9 },
          { header: 'JUNY',     key: 'JU', width: 9 },
          { header: 'JULIOL',   key: 'JL', width: 9 },
          { header: 'AGOST',    key: 'AG', width: 9 },
          { header: 'SETEMBRE', key: 'SE', width: 10 },
          { header: 'OCTUBRE',  key: 'OC', width: 10 },
          { header: 'NOVEMBRE', key: 'NO', width: 10 },
          { header: 'DESEMBRE', key: 'DE', width: 10 },
        ];

        // Column index (1-based) of the target month to highlight it
        const monthColIndex = {
          January: 6, February: 7, March: 8, April: 9, May: 10, June: 11,
          July: 12, August: 13, September: 14, October: 15, November: 16, December: 17
        };
        const targetColIdx = targetMonthKey ? monthColIndex[targetMonthKey] : null;

        worksheet.getRow(1).eachCell((cell, colNumber) => {
          const isTarget = colNumber === targetColIdx;
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: isTarget ? 'FFCC0000' : 'FFFF6600' } };
          cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
        });
        worksheet.getRow(1).height = 22;

        zeroDaysFromTable.forEach(s => {
          const row = worksheet.addRow({
            CODI:  s.CODI_BECARI,
            DNI:   s.DNI_NIE_PASSAPORT || s.DNI,
            NOM:   s.COGNOMS_NOM || s.NOM,
            INICI: s.DATA_INICI ? format(new Date(s.DATA_INICI), 'dd/MM/yyyy') : '',
            FI:    s.DATA_FINALITZACIO ? format(new Date(s.DATA_FINALITZACIO), 'dd/MM/yyyy') : '',
            G:  s.January   || 0,
            F:  s.February  || 0,
            MA: s.March     || 0,
            AB: s.April     || 0,
            MG: s.May       || 0,
            JU: s.June      || 0,
            JL: s.July      || 0,
            AG: s.August    || 0,
            SE: s.September || 0,
            OC: s.October   || 0,
            NO: s.November  || 0,
            DE: s.December  || 0,
          });
          row.height = 22;
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 6) {
              const isTarget = colNumber === targetColIdx;
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: isTarget ? 'FFFFCCCC' : 'FFFFF8F8' } };
              if (isTarget) cell.font = { bold: true };
            }
          });
        });
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const today = format(new Date(), 'dd-MM-yyyy');
      const monthSuffix = targetMonthLabel ? `_${targetMonthLabel}` : '';
      saveAs(blobData, `Alumnes_0_dies_practiques${monthSuffix}_${today}.xlsx`);
    } catch (error) {
      console.error('Error generant el report de 0 dies:', error);
    }
  };

  return (
    <div className="print:hidden">
      {zeroDaysFromTable.length > 0 && (
        <div className="flex items-center justify-between px-4 py-2 border-t-2 border-orange-400 bg-gradient-to-r from-orange-50 to-amber-50">
          <div className="flex items-center gap-2">
            {/* <span className="text-2xl select-none">⚠️ </span> */} 
                  <img
                  src={logoAlert}
                  alt="icon"
                  className="flex-shrink-0 w-6 h-6 mt-1" />
            <div>
              <p className="text-sm font-bold leading-tight text-orange-900">
                Alumnes sense dies de pràctiques
                {targetMonthLabel && (
                  <span className="ml-2 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                    {targetMonthLabel}
                  </span>
                )}
              </p>
              <p className="text-xs text-orange-600">
                {user.role_id === 2
                  ? 'Filtrat per dades creuades · 0 dies al mes seleccionat'
                  : `Mes anterior (${targetMonthLabel}) · sense dies registrats`}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 pr-2">
            <div className="flex items-center justify-center text-base font-semibold text-white bg-orange-500 rounded-full shadow w-9 h-9">
              {zeroDaysFromTable.length}
            </div>
            <button
              onClick={downloadZeroDaysFromTable}
              className="flex items-center gap-2 px-4 py-2 text-sm font-bold text-white transition duration-150 ease-in-out bg-orange-500 rounded-lg shadow hover:bg-orange-600 active:bg-orange-700 hover:shadow-md"
            >
              <img
                  src={logoDownload}
                  alt="icon"
                  className="flex-shrink-0 w-4 h-4" />
                  Descarregar Excel
            </button>
          </div>
        </div>
      )}
    <div className="grid grid-cols-12 pr-2 text-center bg-white border-t-2 border-indigo-800">
      {user.role_id === 2 && (
      <div className="flex items-center justify-start col-span-4">
        <button
          onClick={exportToExcel}
          disabled={rowsEmpty}
          hidden={rowsEmpty}
          className="font-bold rounded-lg text-white disabled:opacity-0 hover:{`handleHover`}"
          style={{ width: '85px', marginRight: '5px', height: '85px' }}
        >
          <img
            src={logoExcel}
            alt="icon"
          />
        </button>
        <button
          onClick={exportToText}
          disabled={rowsEmpty}
          hidden={rowsEmpty}
          className="font-bold rounded-lg text-white disabled:opacity-0 hover:{`handleHover`}"
          style={{ width: '85px', marginRight: '5px', height: '85px' }}
        >
          <span
              title="EXPORTAR TXT PER A3"
              className="flex flex-row items-center w-full"
            >
            <img
              src={logoTxt}
              alt="icon"
              style={{ width: '70%' }} 
            />
          </span>
        </button>
      </div>
      )}
      {user.role_id === 1 && (
      <div className="flex items-center justify-center col-span-3">
        <div className="contents">
          <button
            className="font-bold rounded-lg text-white disabled:opacity-0 hover:{`handleHover`}"
            style={{ width: '85px', marginRight: '-60px', height: '85px', zIndex: 2 }}
          >
            <img
              src={logoExcelRound}
              alt="icon"
              style={{ width: '65px', height: '65px' }} // Ajusta el tamaño según sea necesario
              onClick={() => downloadTemplate('students')}
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-[#4DA462] px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-[#308446] hover:shadow-lg hover:scale-105"
            onClick={() => downloadTemplate('students')}
            style={{ paddingLeft: '45px' }} // Ajusta el espacio a la izquierda para acomodar la imagen
          >
            Descarregar Plantilla Alumnes
          </label>
        </div>
        {/* <button
            className="ml-3 font-bold rounded-lg text-white disabled:opacity-0 hover:{`handleHover`}"
            style={{ width: '85px', marginRight: '-60px', height: '85px', zIndex: 2 }}
          >
            <img
              src={logoExcelRound}
              alt="icon"
              style={{ width: '65px', height: '65px' }}
              onClick={() => downloadTemplate('practices')} // Ajusta el tamaño según sea necesario
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-[#4DA462] px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-indigo-800 hover:shadow-lg hover:scale-105"
            onClick={() => downloadTemplate('practices')}
            style={{ paddingLeft: '45px' }} // Ajusta el espacio a la izquierda para acomodar la imagen
          >
            Descarregar Plantilla Pràctiques
          </label> */}
      </div>
      )}
      {user.role_id === 1 && (
        <div className="flex items-center justify-center col-span-3 py-5">
          {/* Importar Alumnes: sempre obre el modal amb stepper (Centre+Fitxer -> Previsualització -> Resultat) */}
          <button
            type="button"
            onClick={handleImportAlumnesClick}
            className="px-4 py-3 ml-4 font-bold text-white transition duration-300 ease-in-out transform bg-indigo-800 rounded-lg cursor-pointer hover:bg-indigo-600 hover:shadow-lg hover:scale-105"
          >
            Importar Alumnes
          </button>
          <label className="px-4 py-3 ml-4 font-bold text-white transition duration-300 ease-in-out transform bg-indigo-800 rounded-lg cursor-pointer hover:bg-indigo-600 hover:shadow-lg hover:scale-105">
            Importar Pràctiques
            <input
              type="file"
              accept=".xlsx"
              onChange={handleFileUploadPracts}
              className="hidden"
            />
          </label>
        </div>
      )}
      {/* {pageOptions.length > 1 && (
        <div
          className={`flex items-center justify-center py-5 ${
            user.role_id === 2 ? 'col-span-4' : 'col-span-3'
          }`}
        >
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="font-bold text-white bg-indigo-800 rounded-full disabled:opacity-0"
            style={{ width: '24px', marginRight: '7px', height: '24px' }}
          >
            <img
              src={flecha}
              width="15"
              height="15"
              className="p-px"
              style={{ transform: 'rotate(180deg)', margin: 'auto' }}
            />
          </button>
          <span>
            Pàgina <strong>{(pageIndex + 1).toLocaleString()}</strong> de{' '}
            <strong>{pageOptions.length.toLocaleString()} {' ('}
              {datos.length.toLocaleString()} registres{')'}
            </strong>
          </span>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="font-bold text-white bg-indigo-800 rounded-full disabled:opacity-0"
            style={{ width: '24px', marginLeft: '7px', height: '24px' }}
          >
            <img
              src={flecha}
              width="15"
              height="15"
              className="p-px"
              style={{ margin: 'auto' }}
            />
          </button>
        </div>
      )} */}

      {pageOptions.length >= 1 && (
  <div
    className={`flex items-center justify-center py-5 ${
      user.role_id === 2 ? 'col-span-4' : 'col-span-3'
    }`}
  >
    {pageOptions.length > 1 && (
      <button
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
        className="font-bold text-white bg-indigo-800 rounded-full disabled:opacity-0"
        style={{ width: '24px', marginRight: '7px', height: '24px' }}
      >
        <img
          src={flecha}
          width="15"
          height="15"
          className="p-px"
          style={{ transform: 'rotate(180deg)', margin: 'auto' }}
        />
      </button>
    )}
    <span>
      Pàgina <strong>{(pageIndex + 1).toLocaleString()}</strong> de{' '}
      <strong>
        {pageOptions.length.toLocaleString()} ({datos.length.toLocaleString()} registres)
      </strong>
    </span>
    {pageOptions.length > 1 && (
      <button
        onClick={() => nextPage()}
        disabled={!canNextPage}
        className="font-bold text-white bg-indigo-800 rounded-full disabled:opacity-0"
        style={{ width: '24px', marginLeft: '7px', height: '24px' }}
      >
        <img
          src={flecha}
          width="15"
          height="15"
          className="p-px"
          style={{ margin: 'auto' }}
        />
      </button>
    )}
  </div>
)}

      <div
        className={`flex items-center py-5 ${
          user.role_id === 2 ? 'justify-end col-span-4' : 'justify-center col-span-3'
        }`}
      >
        {pageOptions.length > 1 && (
          <select
            className="px-4 py-3 ml-4 font-bold text-white transition duration-300 ease-in-out transform bg-indigo-800 rounded-lg cursor-pointer hover:bg-indigo-600 hover:shadow-lg hover:scale-105"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[25, 75, 150, 250, 500].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize} registres
              </option>
            ))}
          </select>
        )}
      </div>

      {/* MODAL: Alumnes amb 0 dies de pràctiques */}
      {showZeroDaysModal && (
        <>
          {/* Fons fosc */}
          <div
            className="fixed top-0 left-0 z-50 w-screen h-screen bg-black bg-opacity-60"
            onClick={() => setShowZeroDaysModal(false)}
          />

          {/* Finestra modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
            <div className="w-full max-w-md mx-4 bg-white border-2 shadow-2xl pointer-events-auto rounded-xl border-amber-400">

              {/* Capçalera */}
              <div className="flex items-center gap-3 px-6 py-4 border-b border-amber-200 bg-amber-50 rounded-t-xl">
                <span className="text-3xl">⚠️</span>
                <div>
                  <h3 className="text-lg font-bold text-amber-800">
                    Alumnes amb 0 dies de pràctiques
                    {zeroDaysMonth && (
                      <span className="ml-2 bg-red-600 text-white text-sm font-bold px-2 py-0.5 rounded-full">
                        {zeroDaysMonth}
                      </span>
                    )}
                  </h3>
                  <p className="text-sm text-amber-600">Importació completada amb avisos</p>
                </div>
              </div>

              {/* Cos */}
              <div className="px-6 py-6">
                <p className="mb-3 text-base text-gray-700">
                  S&apos;han detectat{' '}
                  <span className="text-lg font-bold text-amber-700">
                    {zeroDaysData.length}
                  </span>{' '}
                  alumne{zeroDaysData.length !== 1 ? 's' : ''} amb 0 dies a{' '}
                  <span className="font-bold text-red-700">{zeroDaysMonth}</span>.
                </p>

                {/* Llista d'alumnes afectats */}
                <ul className="px-4 py-3 space-y-1 overflow-y-auto border rounded-lg bg-amber-50 border-amber-200 max-h-40">
                  {zeroDaysData.map((s, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-gray-700">
                      <span className="flex-shrink-0 w-2 h-2 rounded-full bg-amber-400" />
                      <span className="font-semibold">{s["CODI BECARI"]}</span>
                      <span className="text-gray-500">—</span>
                      <span>{s.NOM}</span>
                    </li>
                  ))}
                </ul>

                <p className="mt-4 text-sm text-gray-500">
                  Voleu descarregar un informe Excel amb aquests alumnes?
                </p>
              </div>

              {/* Botons */}
              <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-100 rounded-b-xl">
                <button
                  className="px-5 py-2 font-semibold text-gray-600 transition duration-200 border-2 border-gray-300 rounded-lg hover:bg-gray-100"
                  onClick={() => setShowZeroDaysModal(false)}
                >
                  Ignorar
                </button>
                <button
                  className="flex items-center gap-2 px-5 py-2 font-semibold text-white transition duration-200 bg-green-600 border-2 border-green-600 rounded-lg hover:bg-green-700 hover:border-green-700"
                  onClick={async () => {
                    setShowZeroDaysModal(false);
                    await downloadZeroDaysReport(zeroDaysData);
                  }}
                >
                  <span>📥</span> Descarregar Excel
                </button>
              </div>

            </div>
          </div>
        </>
      )}

      {/* MODAL: Importar Alumnes (stepper: Centre+Fitxer -> Previsualització -> Resultat) */}
      {showImportAlumnesModal && (
        <ImportAlumnesModal
          onClose={() => setShowImportAlumnesModal(false)}
          handleAnalyzeExcel={handleAnalyzeAlumnesExcel}
          handleConfirmImport={handleConfirmImportAlumnes}
        />
      )}
    </div>
    </div>
  );
}

StudentsTableBar.propTypes = {
  previousPage: PropTypes.func,
  canPreviousPage: PropTypes.bool,
  pageIndex: PropTypes.number,
  pageOptions: PropTypes.array,
  nextPage: PropTypes.func,
  canNextPage: PropTypes.bool,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  datos: PropTypes.array,
  onSuccess: PropTypes.func.isRequired,
  onSuccessPracts: PropTypes.func.isRequired,
  activeMonthKey: PropTypes.string,

};